module.exports = __webpack_public_path__ + "static/img/9bg_10.e23e9aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_10.png
// module id = 771
// module chunks = 1